/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, total: NonNullable<unknown> }} Signin_Code_BoxInputs */

const en_signin_code_box = /** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Digit ${i?.position} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Digit {position} of {total}" |
*
* @param {Signin_Code_BoxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_code_box = /** @type {((inputs: Signin_Code_BoxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_BoxInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_signin_code_box(inputs)
});